import AssistantMessage from './AssistantMessage';
import { pickRandomItem } from '../utils/arrayUtils';

const IDLE_TIPS = [
  'Tap two elements on the periodic table, then press Mix to see if they react!',
  'Try mixing Potassium with Water. Stand back!',
  'Noble gases like Helium and Neon are very shy. They almost never react.',
  'Sodium and Chlorine make something you eat every day. Can you guess what?',
  'Metals near the left side of the periodic table love to react with water.',
];

const NEXT_STEP_PICK_ONE_MORE = 'Now pick one more!';
const NEXT_STEP_PRESS_MIX = 'Ready? Press the Mix button!';

const DEFAULT_SAFETY_NOTE = 'Remember: real chemicals can be dangerous. Only do experiments with a grown-up and a proper lab!';

/**
 * Fizzy, the kid scientist. Turns app events into friendly messages.
 * Holds no UI state; the useAssistant hook does that.
 */
export default class Assistant {
  constructor(name) {
    this.name = name;
  }

  createGreeting() {
    return new AssistantMessage({
      title: `Hi! I'm ${this.name}!`,
      text: "Welcome to my lab! Pick two elements from the periodic table below and I'll hold them up. Press Mix and I'll tell you what happened and why!",
      safetyNote: 'Everything here is pretend, so it is totally safe to experiment.',
    });
  }

  createSelectionMessage(substance, selectedCount) {
    const nextStep = selectedCount < 2 ? NEXT_STEP_PICK_ONE_MORE : NEXT_STEP_PRESS_MIX;
    return new AssistantMessage({
      title: `${substance.getDisplayLabel()}`,
      text: `${substance.description} ${nextStep}`,
      mood: 'curious',
      // Say the name (not "H" or "H₂O"), then the description, then what to do next.
      speechSegments: [substance.name, substance.description, nextStep],
    });
  }

  createThinkingMessage() {
    return new AssistantMessage({
      text: 'Mixing... watch closely!',
      mood: 'excited',
    });
  }

  createExplanation(reaction) {
    return new AssistantMessage({
      title: reaction.title,
      text: reaction.explanation,
      funFact: reaction.funFact,
      safetyNote: reaction.hasVisibleReaction() ? reaction.safetyNote || DEFAULT_SAFETY_NOTE : '',
      mood: reaction.hasVisibleReaction() ? 'amazed' : 'thinking',
    });
  }

  /**
   * Every tip Fizzy can give, so they can all be recorded ahead of time.
   */
  getAllTips() {
    return IDLE_TIPS.map((tipText) => new AssistantMessage({ title: 'Tip!', text: tipText }));
  }

  createIdleTip() {
    return new AssistantMessage({
      title: 'Tip!',
      text: pickRandomItem(IDLE_TIPS),
    });
  }
}
